import { render, staticRenderFns } from "./SignUpSuccess.vue?vue&type=template&id=0b90c0a2&scoped=true"
import script from "./SignUpSuccess.vue?vue&type=script&lang=js"
export * from "./SignUpSuccess.vue?vue&type=script&lang=js"
import style0 from "./SignUpSuccess.vue?vue&type=style&index=0&id=0b90c0a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90c0a2",
  null
  
)

export default component.exports